import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { importProducts } from "../../api/productService";
import { getErrorMessage } from "../../utils/errorHandler";

export default function ImportProducts() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const selected = e.target.files[0];

    if (!selected) return;

    if (!selected.name.endsWith(".csv")) {
      setError("Please select a CSV file.");
      return;
    }

    setFile(selected);
    setError("");
    setSuccess("");
  };

  const handleDrop = (e) => {
    e.preventDefault();

    const selected = e.dataTransfer.files[0];

    if (!selected) return;

    if (!selected.name.endsWith(".csv")) {
      setError("Please upload a CSV file.");
      return;
    }

    setFile(selected);
    setError("");
    setSuccess("");
  };

  const removeFile = () => {
    setFile(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

//   const handleUpload = async () => {
//     if (!file) {
//       setError("Please select a CSV file.");
//       return;
//     }

//     try {
//       setLoading(true);
//       setProgress(20);

//       const formData = new FormData();
//       formData.append("file", file);

//       await importProducts(formData);

//       setProgress(100);

//       setSuccess("Products imported successfully.");

//       removeFile();
//     } catch (err) {
//       setError(getErrorMessage(err));
//     } finally {
//       setLoading(false);
//     }
//   };

  return (
    <div className="container-fluid p-4">
      <div className="card shadow border-0">
        <div className="card-header bg-white d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Import Products</h4>

          <button
            className="btn btn-secondary"
            onClick={() => navigate("/products")}
          >
            Back
          </button>
        </div>

        <div className="card-body">
          {success && <div className="alert alert-success">{success}</div>}

          {error && <div className="alert alert-danger">{error}</div>}

          <div
            className="border rounded p-5 text-center bg-light"
            style={{
              borderStyle: "dashed",
              cursor: "pointer",
            }}
            onClick={() => fileInputRef.current.click()}
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
          >
            <i
              className="fa fa-cloud-upload"
              style={{
                fontSize: "50px",
                color: "#0d6efd",
              }}
            />

            <h5 className="mt-3">Drag & Drop CSV File Here</h5>

            <p className="text-muted">or click to browse</p>

            <input
              ref={fileInputRef}
              hidden
              type="file"
              accept=".csv"
              onChange={handleFileChange}
            />
          </div>

          {file && (
            <div className="card mt-4">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <h6>Selected File</h6>

                  <p className="mb-1 text-primary">{file.name}</p>

                  <small className="text-muted">
                    {(file.size / 1024).toFixed(2)} KB
                  </small>
                </div>

                <button className="btn btn-outline-danger" onClick={removeFile}>
                  Remove
                </button>
              </div>
            </div>
          )}

          {loading && (
            <div className="mt-4">
              <div className="progress">
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  style={{
                    width: `${progress}%`,
                  }}
                >
                  {progress}%
                </div>
              </div>
            </div>
          )}

          <div className="text-end mt-4">
            <button
              className="btn btn-primary px-5"
              disabled={!file || loading}
            //   onClick={handleUpload}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Importing...
                </>
              ) : (
                <>
                  <i className="fa fa-upload me-2"></i>
                  Import Products
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
